import VideoMainHeading from '../components/videoMainHeading';
import React from 'react';
import { useInView } from 'react-intersection-observer';

function Video() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <div className="relative overflow-hidden flex flex-col justify-center items-center">
      <div
        className="bg-moon-bg-pattern-css flex flex-col justify-start items-center text-center relative"
        ref={ref}
      >
        {inView && <VideoMainHeading />}
      </div>
    </div>
  );
}

export default React.memo(Video);
